import { fetchFromUrlPOSTAsync } from '../utils/UrlHelper';

// إشعارات التطبيق (بدون Firebase): الأدمن بيكتب الإشعار، والموبايل بيقراه من الـ API.
const URL_MOBILE_LIST = '/notifications/list';

const URL_ADMIN_LIST = '/admins/notifications/list';
const URL_ADMIN_CREATE = '/admins/notifications/create';
const URL_ADMIN_DELETE = '/admins/notifications/delete';

const READ_STORAGE_KEY = 'saffati_read_notifications';
const MAX_STORED_READ_IDS = 300;

const getId = (item) =>
  String(item?.idKey ?? item?.id ?? item?.idNotification ?? item?._id ?? '');

const pickLang = (item, field, isArabic) => {
  const ar = item?.[`${field}_ar`];
  const en = item?.[`${field}_en`];
  if (isArabic) return ar || en || item?.[field] || '';
  return en || ar || item?.[field] || '';
};

const fs = {
  // ---------- Mobile ----------
  listForMobile: async (params = {}) => {
    return await fetchFromUrlPOSTAsync(URL_MOBILE_LIST, {
      page: 1,
      limit: 50,
      ...params,
    });
  },

  // ---------- Admin ----------
  adminList: async (params = {}) => {
    return await fetchFromUrlPOSTAsync(URL_ADMIN_LIST, {
      page: 1,
      limit: 100,
      ...params,
    });
  },
  adminCreate: async (values) => {
    return await fetchFromUrlPOSTAsync(URL_ADMIN_CREATE, {
      saveData: {
        title_ar: values.title_ar,
        title_en: values.title_en,
        body_ar: values.body_ar,
        body_en: values.body_en,
      },
    });
  },
  adminDelete: async (idKey) => {
    return await fetchFromUrlPOSTAsync(`${URL_ADMIN_DELETE}/${idKey}`, {});
  },
};

const loc = {
  getId,

  extractList: (result) => {
    const data = result?.data;
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.list)) return data.list;
    if (Array.isArray(data?.rows)) return data.rows;
    if (Array.isArray(data?.data)) return data.data;
    return [];
  },

  normalize: (item, isArabic) => ({
    idKey: getId(item),
    title: pickLang(item, 'title', isArabic),
    body: pickLang(item, 'body', isArabic) || item?.message || '',
    createdAt: item?.created_at || item?.createdAt || item?.date || null,
  }),

  getReadIds: () => {
    try {
      const raw = localStorage.getItem(READ_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return new Set(Array.isArray(parsed) ? parsed.map(String) : []);
    } catch (e) {
      return new Set();
    }
  },

  saveReadIds: (idsSet) => {
    try {
      const list = Array.from(idsSet).slice(-MAX_STORED_READ_IDS);
      localStorage.setItem(READ_STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  },
};

const NotificationActions = Object.assign(fs, loc);

export default NotificationActions;
